enum JobState {
  Standing = "standing",
  Processing = "processing",
  Success = "success",
  Failed = "Failed",
}
export default JobState;
